import { v1 as uuidv1 } from 'uuid';
import { IFieldType } from './IFieldType';
import { WithOptional } from './WithOptional';

/**
 * Create a factory/constructor function for a field type.
 *
 * The constructor will provide defaults for the "id", "visibility", and "readOnly" fields.
 * Those defaults must be present when fields are serialized to XML, because parseField requires them.
 */
export function createFieldTypeFactory<T extends IFieldType<any>>(type: T['type'], emptyValue: T['emptyValue']) {
    return (value: Omit<WithOptional<T, 'visibility' | 'id' | 'readOnly'>, 'type' | 'emptyValue'>) => {
        return {
            ...value,
            type,
            id: value.id ?? uuidv1(),
            visibility: value.visibility ?? 'AlwaysVisible',
            readOnly: value.readOnly ?? false,
            emptyValue,
        };
    };
}
